import {
  ApiAppNamespaces,
  ApiBackofficeNamespaces,
  IQueuedRequest,
  OneAPIOptions
} from '../../common'
import { AppStocksApi } from './app'
import { BackofficeStocksApi } from './backoffice'
import { Queue } from '../../queue'

export class StocksApp implements ApiAppNamespaces {
  app: AppStocksApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppStocksApi(name, sessionId, requestsQueue, options)
  }

  invalidateAll() {
    this.app.invalidateAll()
  }
}

export class StocksBackoffice implements ApiBackofficeNamespaces {
  backoffice: BackofficeStocksApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.backoffice = new BackofficeStocksApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.backoffice.invalidateAll()
  }
}
